// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { listTree16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-list-tree': IconListTree;
    }
}

/**
 * The icon component for the 'listTree' icon
 */
export class IconListTree extends IconSvg {
    public constructor() {
        super(listTree16X16);
    }
}

registerIconSvg('icon-list-tree', IconListTree);
export const iconListTreeTag = 'nimble-icon-list-tree';
